// extracted by mini-css-extract-plugin
module.exports = {"tooltipText":"UKTruncatedTooltip_tooltipText__zx_yo","displayTxt":"UKTruncatedTooltip_displayTxt__s3B4F"};